import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Webhook, CheckCircle2, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmt = (v) => (v ? new Date(v).toLocaleString('id-ID') : '-');

// Delta #72: panel webhook status pengiriman Qontak (delivered/read/failed)
export const QontakWebhookPanel = ({ config, loadConfig }) => {
  const [busy, setBusy] = useState(false);
  const registered = Boolean(config.qontak_webhook_url);

  const register = async () => {
    if (!window.confirm('Daftarkan URL webhook status pengiriman ke Qontak?\n\nCatatan: ini MENGGANTI URL webhook "message interaction" yang mungkin sudah terpasang di akun Qontak Anda.')) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API_URL}/api/whatsapp/mekari/webhook/register`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (r.data?.success) {
        toast.success('Webhook status pengiriman aktif');
        if (loadConfig) loadConfig();
      } else {
        toast.error(`Gagal daftar webhook: ${r.data?.error || r.data?.data || 'unknown'}`);
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Gagal daftar webhook');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-md border border-emerald-200 dark:border-emerald-800 bg-white/60 dark:bg-gray-900/40 p-3 space-y-2" data-testid="qontak-webhook-panel">
      <Label className="font-semibold">Status Pengiriman & Nomor Tidak Aktif</Label>
      <p className="text-[11px] text-gray-600 dark:text-gray-400">
        Sistem mengecek status tiap pesan (Diterima / Dibaca / Gagal) otomatis tiap 10 menit. Nomor yang gagal terkirim
        2x berturut-turut atau formatnya mustahil akan ditandai <b>WA Tidak Aktif</b> dan tidak dikirimi lagi (hemat biaya).
        Aktifkan webhook agar status masuk seketika.
      </p>
      {registered && (
        <div className="text-[11px] space-y-0.5" data-testid="qontak-webhook-status">
          <div className="flex items-center gap-1 text-emerald-700 dark:text-emerald-400 font-semibold">
            <CheckCircle2 className="w-3.5 h-3.5" /> Webhook aktif sejak {fmt(config.qontak_webhook_registered_at)}
          </div>
          <div className="font-mono break-all text-gray-500">{config.qontak_webhook_url.replace(/\/[^/]+$/, '/••••••')}</div>
          <div className="flex items-center gap-1 text-gray-500">
            <Clock className="w-3 h-3" /> Event terakhir diterima: {fmt(config.qontak_webhook_last_event_at)}
          </div>
        </div>
      )}
      <Button size="sm" variant="outline" onClick={register} disabled={busy} data-testid="qontak-webhook-register-btn">
        <Webhook className={`w-3.5 h-3.5 mr-1 ${busy ? 'animate-pulse' : ''}`} />
        {busy ? 'Mendaftarkan...' : registered ? 'Daftarkan Ulang Webhook' : 'Aktifkan Webhook Real-time'}
      </Button>
    </div>
  );
};

export default QontakWebhookPanel;
